"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const search_input_1 = __importDefault(require("../search-input"));
const checkbox_1 = __importDefault(require("../checkbox"));
const StyledMenuWrapper = styled_components_1.default.div `
  max-width: 520px;
  width: fit-content;
  border: solid 1px ${({ theme }) => theme.neutral.light};
  border-radius: 4px;
  background-color: white;
  padding: 7px 12px;
`;
const StyledItemsList = styled_components_1.default.div `
  max-height: 300px;
  padding: 0 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow-y: auto;
  overflow-x: visible;
`;
const StyledClearButton = styled_components_1.default.div `
  font-size: 12px;
  color: ${({ theme }) => theme.primary.main};
  margin: 10px;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.primary.main};
  }
  &:active {
    color: ${({ theme }) => theme.primary.main};
  }
`;
const StyledTextMessage = styled_components_1.default.div `
  color: ${({ theme }) => theme.text.secondary};
  font-size: 14px;
  font-weight: 200;
`;
const RotaMultiSelectMenu = ({ items, onSelect, onSearch, onClear, searchPlaceholder, showSearchInput = true }) => {
    return (react_1.default.createElement(StyledMenuWrapper, null,
        showSearchInput && (react_1.default.createElement(search_input_1.default, { placeholder: searchPlaceholder, onChange: (value) => onSearch(value), styles: { margin: "10px 0" } })),
        react_1.default.createElement(StyledItemsList, null,
            items.map(item => (react_1.default.createElement(checkbox_1.default, { key: item.value, label: item.label, isChecked: item.selected, onClick: () => {
                    onSelect(item);
                } }))),
            !items.length && (react_1.default.createElement(StyledTextMessage, null, "No items found..."))),
        react_1.default.createElement(StyledClearButton, { onClick: () => onClear() }, "Clear")));
};
exports.default = RotaMultiSelectMenu;
